import React from 'react';
import type { Level } from './LevelChip';

interface LevelTagProps {
  /** The text, e.g. "Organisation". */
  label: string;
  /** Picks the level's colour (`sw-level-tag--<level>`). */
  level?: Level;
  icon?: React.ReactNode;
  className?: string;
}

/** The one level-tag look (Organisation / Entity / Workspace), matching the sidebar's Administration pill. */
const LevelTag: React.FC<LevelTagProps> = ({ label, level, icon, className }) => {
  const classes = ['sw-level-tag', level && `sw-level-tag--${level}`, className].filter(Boolean).join(' ');
  return (
    <span className={classes}>
      {icon}
      {label}
    </span>
  );
};

export default LevelTag;
